import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { REDIRECT_ON_403 } from './auth-403.context';

export const auth403OnlyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const router = inject(Router);
  const shouldRedirect = req.context.get(REDIRECT_ON_403);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (shouldRedirect && err instanceof HttpErrorResponse && err.status === 403) {
        router.navigate(['exception', 'NO_CUSTOMER']);
      }
      return throwError(() => err);
    }),
  );
};